<template>
  <Modal ref="infoModal" title="Informações">
    <div class="modal-container">
      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <template v-else>
        <div class="input-row">
          <Input legend="Autoescola" :modelValue="details.nome_fantasia || '-'" :readonly="true" />
          <Input legend="CNPJ" :modelValue="details.cnpj || '-'" :readonly="true" />
        </div>
        <div class="input-row">
          <Input legend="E-mail" :modelValue="details.email || '-'" :readonly="true" />
          <Input legend="Telefone" :modelValue="details.telefone || '-'" :readonly="true" />
        </div>
        <div class="input-row">
          <Input legend="Endereço" :modelValue="details.endereco || '-'" :readonly="true" />
        </div>
      </template>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Input from 'core/Input'

export default {
  name: 'InfoModal',
  components: {
    Modal,
    LoadingSpinner,
    Input,
  },
  data() {
    return {
      details: {},
      loading: false,
    }
  },
  methods: {
    async open(id) {
      await this.detalhes(id)
    },
    async detalhes(id) {
      this.$refs.infoModal.open()
      this.loading = true

      await this.$http.get(`${process.env.VUE_APP_URL_API}/cfc/${id}`)
        .then(response => {
          console.log(response.body.dados.cfc)
          this.details = response.body.dados.cfc
        })
        .catch(err => {
          this.$toasted.show('Não foi possivel exibir os detalhes da autoescola', {
            position: 'top-right',
          });

          this.$refs.infoModal.close()
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 60vw;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .input-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    >div {
      flex: 1;
    }
  }
}
</style>